import React from 'react';
import cx from 'classnames';
import { ChevronForwardRoundedFilledIcon } from '@unisporkal/alliance-ui';
import styles from './CaretText.module.scss';

export type CaretTextProps = {
  children: React.ReactNode;
  className?: string;
  caretClassName?: string;
  caretSize?: string;
};

const CaretText = ({
  children,
  className,
  caretClassName,
  caretSize = '1.5em',
}: CaretTextProps) => (
  <span className={cx(styles.container, className)}>
    {children}
    <ChevronForwardRoundedFilledIcon
      className={cx(styles.caret, caretClassName)}
      size={caretSize}
    />
  </span>
);

export default CaretText;
